import { NgModule, Injector, FactoryProvider, APP_INITIALIZER } from '@angular/core';
import { OIDCAuthService } from '@core/auth/oidc-auth.service';
import { OIDCRoleService } from '@core/auth/oidc-role.service';
import { AUTH_SERVICE, ROLE_SERVICE } from '@core/auth/token';
import { AuthServiceInterface } from '@core/auth/auth.interface';
import { RoleServiceInterface } from '@core/auth/role.interface';
import { environment } from '@env/environment';
import { OAuthModule, OAuthService } from 'angular-oauth2-oidc';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthTokenInterceptor } from '@core/auth/auth-token.interceptor';
import { AuthErrorInterceptor } from '@core/auth/auth-error.interceptor';

const authServiceProvider: FactoryProvider = {
  provide: AUTH_SERVICE,
  useFactory: (injector: Injector): AuthServiceInterface => {
      return injector.get(OIDCAuthService);
    },
  deps: [Injector]
};

const roleServiceProvider: FactoryProvider = {
  provide: ROLE_SERVICE,
  useFactory: (injector: Injector): RoleServiceInterface => {
      return injector.get(OIDCRoleService);
    },
  deps: [Injector]
};

export function oidcInitializerFactory(oidcAuthService: OIDCAuthService): () => Promise<void> {
  return () => oidcAuthService.runInitialLoginSequence();
}

const oidcImports = [
  OAuthModule.forRoot({
    resourceServer: {
      // TODO : move to environment-xxx.ts
      allowedUrls: [
        //'/api/', // For relative backend API calls
        environment.avatarUrl,
        environment.profileUrl,
        'http://localhost:4200', // angular proxy
        //'http://localhost:8091', // oidc keycloak auth
        'http://localhost:9090', // maps-backend
        //'http://localhost:8080'  // avatar service
        // 'http://localhost:8080'  // profile service
      ],
      sendAccessToken: true,
    }
  })
];

const oidcSetupProviders = [
  { provide: APP_INITIALIZER, useFactory: oidcInitializerFactory, deps: [OIDCAuthService], multi: true, },
  { provide: HTTP_INTERCEPTORS, useClass: AuthTokenInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: AuthErrorInterceptor, multi: true },
];

const oidcServiceProviders = [
  OIDCAuthService,
  OIDCRoleService,
  OAuthService
];

@NgModule({
  imports: [ ...oidcImports ],
  providers: [
    authServiceProvider,
    roleServiceProvider,
    oidcSetupProviders,
    oidcServiceProviders
  ]
})

export class AuthModule {
  constructor() {
    console.log('[AuthModule] AuthModule has been loaded.');
    this.cleanUpOAuth2();
  }

  private cleanUpOAuth2() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('id_token');
    localStorage.removeItem('nonce');
    localStorage.removeItem('PKCE_verifier');
  }
}
